import { Injectable, inject } from '@angular/core'

import { AppConfigService } from 'app/app-config.service'
import { ConfigStore } from 'app/store/config.store'

@Injectable({ providedIn: 'root' }) // one instance app-wide
export class LogoService {
  private configStore = inject(ConfigStore)
  private appConfigService = inject(AppConfigService)

  get src(): string {
    const configLogo = this.configStore.config()?.settings?.logo

    if (Array.isArray(configLogo) && configLogo.length === 0) {
      return (
        this.appConfigService.getAppConfig?.logo?.full_path || 'assets/img/logo-placeholder.png'
      )
    }

    if (!configLogo) {
      return (
        this.appConfigService.getAppConfig?.logo?.full_path || 'assets/img/logo-placeholder.png'
      )
    }

    if (Array.isArray(configLogo)) {
      return configLogo[0] || 'assets/img/logo-placeholder.png'
    }

    return configLogo
  }
}
